import { css } from 'styled-components'
import { rem } from 'polished'

const Typography = css`
  b,
  strong {
    font-weight: ${props => props.theme.font.primary.weight.superBold};
  }

  p {
    margin-top: 0;
    margin-bottom: 0;

    & + & {
      margin-top: ${rem(24)};
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0;
    margin-bottom: 0;
    //To prevent unsemantic use heading not have sizes
    font-size: inherit;
    font-weight: ${props => props.theme.font.primary.weight.regular};
  }

  ol,
  ul {
    padding-inline-start: 0;
    margin-top: ${rem(24)};
    margin-inline-start: ${rem(20)};
  }

  dl {
    margin: 0;
  }

  dd {
    margin-inline-start: 0;
  }

  ::-webkit-input-placeholder,
  :-ms-input-placeholder,
  ::-ms-input-placeholder,
  ::-moz-placeholder {
    color: ${props => props.theme.palette.neutral.surface.lightForegroundAlt};
  }

  sup, sub {
    line-height: .5;
  }

  /* CJK fonts have no italics, so stop the browser slanting them; Latin text keeps its real italic */
  :lang(ja), :lang(ko), :lang(zh) {
    font-synthesis-style: none;
  }
`

export default Typography
